import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { TipoIstanzaFascicoloVO } from "../vo/tipo-istanza-fascicoloVO";
import { TipoIstanzaFascicoloDTO } from "../dto/tipo-istanza-fascicoloDTO";
import { ClassificaDTO } from "../dto/classificaDTO";
import { ClassificaVO } from "../vo/classificaVO";

@Injectable({
  providedIn: "root",
})
export class MapperClassifica
  implements MapperInterface<ClassificaDTO, ClassificaVO> {
  convertVoToDto(vo: ClassificaVO): ClassificaDTO {
    console.log("MapperClassifica convertVoToDto BEGIN", vo);
    if (vo) {
      const dto = new ClassificaDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.id = vo.id;
      dto.codice = vo.codice;
      dto.nome = vo.nome;
      console.log("MapperClassifica convertVoToDto END", dto);
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: ClassificaDTO): ClassificaVO {
    if (dto) {
      const vo = new ClassificaVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.output = dto.codice + " - " + dto.nome;
      vo.id = dto.id;

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: ClassificaVO[]): ClassificaDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: ClassificaDTO[]): ClassificaVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
